<template>
    <div class="PmsOrder">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>BBAC专属</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>价格查询</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div style="display: flex;">
                    <span>注意：价格查询数据仅保留最近30天的查询结果</span>
                    <span style="flex-grow: 1;"></span>
                    <el-button type="primary" @click="() => uploadDialogVisible = true" size="mini">上传</el-button>
                </div>
            </el-card>
        </main>
        <el-dialog title="上传" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                class="upload-demo"
                drag
                action="/api/admin/tool/createOrderFromPms"
                :limit="1"
                accept=".xlsx"
                :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
export default {

    data() {
        return {
            uploadDialogVisible: false,
        }
    },
    methods: {
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
    },
}
</script>
<style>
</style>
